import contractInfo from './contracts/contract-address.json'

const config = {
    "CONTRACT_ADDRESS": contractInfo.address,
    "GAS_LIMIT": 285000,
    "COLLECTION_URL": "https://testnets.opensea.io/collection/friendly-skull-reveal",
  }

export default config;
